import { Pagination, Table } from "antd";
import moment from "moment";

const PendingRecieptDataTable = (props) => {
  const columns = [
    {
      title: "DATE",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (
        <div className="collection-table-item">
          {moment.utc(createdAt).format("DD-MM-YYYY")}
        </div>
      ),
      width: 100,
    },
    {
      title: "TIME NEW",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (
        <div className="collection-table-item">
          {moment(createdAt).format("HH:mm:ss")}
        </div>
      ),
      width: 100,
    },
    {
      title: "BOX NO",
      dataIndex: "box_number",
      key: "box_number",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "RATE",
      dataIndex: "rate",
      key: "rate",
      render: (text) => <div>{text || 0}</div>,
    },
    {
      title: "WEIGHT",
      dataIndex: "chargable_weight",
      key: "chargable_weight",
      render: (text) => <div>{text || 0}</div>,
    },
    {
      title: "SERVICE",
      dataIndex: "",
      key: "",
      render: (text) => {
        return <div>{text?.service?.name}</div>;
      },
    },
    {
      title: "PACKING CHARGE",
      dataIndex: "packing_charge",
      key: "packing_charge",
      render: (text) => <div>{text || 0}</div>,
    },
    {
      title: "DUTY CHARGE",
      dataIndex: "duty",
      key: "duty",
      render: (text) => <div>{text || 0}</div>,
    },
    {
      title: "TOTAL AMOUNT",
      dataIndex: "totalCharge",
      key: "totalCharge",
      render: (text) => <div>{Number(text).toFixed(1) || 0}</div>,
      align: "center",
    },
    // {
    //   title: "STATUS",
    //   dataIndex: "status_message",
    //   key: "status_message",
    //   render: (text) => <Tag>{text}</Tag>,
    // },
    {
      title: "CREATED BY",
      dataIndex: "created_user",
      key: "created_user",
      render: (user) => <div>{user?.name}</div>,
    },
  ];

  const handlePaginationChange = (newPage, newPageSize) => {
    if (props.PageOnchange) {
      props.PageOnchange(newPage, newPageSize);
    }
  };

  return (
    <div>
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        columns={columns}
        dataSource={props?.data}
        pagination={false}
        size="small"
        rowKey={(record) => record?.box_number}
        responsive
        scroll={{ x: true }}
      />
      <br />
      <div align="right">
        <Pagination
          responsive
          current={props?.meta?.page || 1}
          total={props?.meta?.itemCount || 0}
          pageSize={props?.meta?.take || 10}
          onChange={handlePaginationChange}
          showSizeChanger
          // pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </div>
  );
};

export default PendingRecieptDataTable;
